import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

const initialState = {
  counter: 0,
};
export const reminderSlice = createSlice({
  name: 'reminder',
  initialState,
  reducers: {
    updateCounter: (state) => {
      state.counter = state.counter + 1;
    },
  },
});

export const { updateCounter } = reminderSlice.actions;

export const counter = (state: RootState) => state.reminder.counter;
